import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined'
import { Box, ButtonBase, CardContent, Fade, Grid, Popover, Stack, Typography } from '@mui/material'
import { useAuthContext } from 'components/context/AuthProvider'
import { MouseEvent, useState } from 'react'
import { useTheme } from 'themes/useTheme'
import { ProfileList } from './ProfileList'

const Profile = () => {
  const theme = useTheme()

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

  const handleOpen = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)

  const { profileName, position } = useAuthContext()

  return (
    <Box sx={{ flexShrink: 0, ml: 0.75 }}>
      <ButtonBase
        sx={{
          p: 0.25,
          bgcolor: open ? 'grey.300' : 'transparent',
          borderRadius: 1,
          '&:hover': { bgcolor: 'secondary.lighter' },
        }}
        aria-label="open profile"
        aria-controls={open ? 'client-forms-grow' : undefined}
        aria-haspopup="true"
        onClick={handleOpen}
      >
        <Stack direction="row" spacing={1} alignItems="center" sx={{ p: 0.5 }}>
          <AccountCircleOutlinedIcon />
          <Typography variant="body1">{profileName}</Typography>
        </Stack>
      </ButtonBase>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        elevation={1}
        anchorOrigin={{
          vertical: 44,
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        TransitionComponent={Fade}
      >
        <Box
          sx={{
            width: 290,
            minWidth: 240,
            maxWidth: 290,
            [theme.breakpoints.down('md')]: {
              maxWidth: 250,
            },
          }}
        >
          <CardContent sx={{ px: 2.5, pt: 3 }}>
            <Grid container justifyContent="space-between" alignItems="center">
              <Grid item>
                <Stack direction="row" spacing={1.25} alignItems="center">
                  <AccountCircleOutlinedIcon />
                  <Stack>
                    <Typography variant="h6">{profileName}</Typography>
                    <Typography variant="body2" color="textSecondary">
                      {position}
                    </Typography>
                  </Stack>
                </Stack>
              </Grid>
            </Grid>
          </CardContent>

          <ProfileList onClose={handleClose} />
        </Box>
      </Popover>
    </Box>
  )
}

export default Profile
